var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { useFilespaceWebFsLogout } from '@lucidlink/workspacemanagement';
export const useFilespaceQuit = (retry = 0) => {
    _react_refresh_temp_1();
    const { mutation: { mutateAsync: filespaceWebFsLogout }, } = useFilespaceWebFsLogout();
    const mutation = useMutation({
        mutationFn: async ({ filespaceId, workspaceId }) => {
            await filespaceWebFsLogout({ workspaceId, filespaceId });
        },
        networkMode: 'always',
        retry,
    });
    return { mutation };
};
_react_refresh_temp_1(useFilespaceQuit, "5e0EvZyFxDkQTSfQwbuGmU2bvQg=", false, () => [useFilespaceWebFsLogout, useMutation]);
